import { Company } from 'typings/common_defs'
import { api } from 'api'

export const FALL_BACK_TAKE_PERCENTAGE = 20

export type CompanyInfo = Required<
  Pick<
    Company,
    | 'name'
    | 'id'
    | 'logoUrl'
    | 'companyGroup'
    | 'takePercentageEstimate'
    | 'bonusTakePercentageEstimate'
    | 'chargeUpfront'
    | 'w2'
    | 'backfillPolicy'
  > & {
    hasVndlyIntegration: boolean
  }
>

// a lightweight version of getting current company info
export async function getCurrentCompanyInfo() {
  const response = await api.post<CompanyInfo>(
    '/company/graphql_dispatch/current_company_e542fced',
    {}
  )

  const company = response.data

  if (!company) {
    return null
  }

  return {
    ...company,
    id: Number(company.id),
    takePercentageEstimate: Number(company.takePercentageEstimate),
    bonusTakePercentageEstimate: Number(company.bonusTakePercentageEstimate),
  }
}

export async function switchCompany(
  currentCompanyId: number,
  newCompanyId: number
) {
  return api.post(`/company/${currentCompanyId}/group/switch_company`, {
    new_company_id: newCompanyId,
  })
}
